import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

import axiosRestaurantInstance from './AxiosRestaurantInstance';

import "./css/Menu.css";


const Menu = ({
    showAddMenu,
    newMenuItem,
    handleInputChange,
    handleAddNewItem,
    handleCloseAddMenu,
    menuItems,
    setMenuItems,
    editingItem,
    handleEditClick,
    handleDeleteMenuItem,
    handleUpdateItem,
    handleCancelEdit,
    foodCategories,
    restaurantId,
    handleAddMenu,
}) => {

    // Function to fetch updated menu items from the database
    const fetchMenuItems = async () => {
        try {
            const response = await axiosRestaurantInstance.get(`/get_menu_items/${restaurantId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch menu items');
            }
            const data = await response.json();
            setMenuItems(data); // Assuming the response returns the menu items
        } catch (error) {
            console.error('Error fetching menu items:', error);
        }
    };

    // Modify handleAddNewItem to include fetching updated menu items
    const handleAddNewItemWithRefresh = async (event) => {
        event.preventDefault(); // Ensure the form does not reload the page
        await handleAddNewItem(event); // Pass the event here
        await fetchMenuItems(); // Fetch the updated menu items after adding the new one
    };
    

    return (
        <div className="menu">
            <div className='menu-heading'>
                <h2>Menu</h2>
                <div className='addmenu-button'>
                    <button className="add-button" onClick={handleAddMenu}>Add Menu</button>
                </div>
            </div>

            {/* Show Add Menu Form */}
            {showAddMenu && (
                <div className="add-menu-form">
                    <select
                        name="foodType"
                        value={newMenuItem.foodType}
                        onChange={handleInputChange}
                    >
                        <option value="">Select Food Type</option>
                        {foodCategories.map(category => (
                            <option key={category.FoodType} value={category.FoodType}>
                                {category.FoodType}
                            </option>
                        ))}
                    </select>
                    {/* Input Fields */}
                    <input
                        type="text"
                        name="foodItem"
                        placeholder="Food Item"
                        value={newMenuItem.foodItem}
                        onChange={handleInputChange}
                    />
                    <input
                        type="number"
                        name="price"
                        placeholder="Price"
                        value={newMenuItem.price}
                        onChange={handleInputChange}
                    />
                    <input
                        type="text"
                        name="quantity"
                        placeholder="Quantity"
                        value={newMenuItem.quantity}
                        onChange={handleInputChange}
                    />
                    <input
                        type="text"
                        name="notes"
                        placeholder="Notes"
                        value={newMenuItem.notes}
                        onChange={handleInputChange}
                    />
                    <input
                        type="text"
                        name="ingredients"
                        placeholder="Ingredients"
                        value={newMenuItem.ingredients}
                        onChange={handleInputChange}
                    />
                    <button className="add-button" onClick={handleAddNewItemWithRefresh}>Add</button>
                    <button className="close-button" onClick={handleCloseAddMenu}>Close</button>
                </div>
            )}

            {/* Render menu items in a table format */}
            {Object.keys(menuItems).length > 0 ? (
                Object.keys(menuItems).map(foodType => (
                    <div key={foodType}>
                        <h4>{foodType}</h4>
                        <table className="menu-table">
                            <thead>
                                <tr>
                                    <th>Food Item</th>
                                    <th>Price (rupees)</th>
                                    <th>Quantity</th>
                                    <th>Notes</th>
                                    <th>Ingredients</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {menuItems[foodType].map((item, index) => (
                                    <tr key={index} className={editingItem === item ? 'editing' : ''}>
                                        {editingItem === item ? (
                                            <>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={item.Food_Item}
                                                        onChange={(e) => { item.Food_Item = e.target.value; setMenuItems({ ...menuItems }); }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={item.Price}
                                                        onChange={(e) => { item.Price = e.target.value; setMenuItems({ ...menuItems }); }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={item.Quantity}
                                                        onChange={(e) => { item.Quantity = e.target.value; setMenuItems({ ...menuItems }); }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={item.Notes}
                                                        onChange={(e) => { item.Notes = e.target.value; setMenuItems({ ...menuItems }); }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={item.Ingredients}
                                                        onChange={(e) => { item.Ingredients = e.target.value; setMenuItems({ ...menuItems }); }}
                                                    />
                                                </td>
                                                <td>
                                                    <button className="update-button" onClick={() => handleUpdateItem({
                                                        Food_Item_Id: item.Food_Item_Id,
                                                        restaurantId: restaurantId,
                                                        foodType: item.Food_Type,
                                                        foodItem: item.Food_Item,
                                                        price: item.Price,
                                                        quantity: item.Quantity,
                                                        notes: item.Notes,
                                                        ingredients: item.Ingredients
                                                    })}>
                                                        Update
                                                    </button>
                                                    <button className="close-button" onClick={handleCancelEdit}>Close</button>
                                                </td>
                                            </>
                                        ) : (
                                            <>
                                                <td>{item.Food_Item}</td>
                                                <td>{item.Price}</td>
                                                <td>{item.Quantity}</td>
                                                <td>{item.Notes}</td>
                                                <td>{item.Ingredients}</td>
                                                <td>
                                                    <button className="action-button" onClick={() => handleEditClick(item)}>
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                    <button className="action-button delete-button" onClick={() => handleDeleteMenuItem(item.Food_Item_Id)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </td>
                                            </>
                                        )}
                                    </tr>
                                ))}  
                            </tbody>
                        </table>
                    </div>
                ))
            ) : (
                <p>No menu items available.</p>
            )}
        </div>
    );
};

export default Menu;
